<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Edit Setting</h1>
    </div>
    <div class="">
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
          <input type="text" class="form-control" disabled id="form-name" placeholder="Name" v-model="key">
        </div>
      </div>
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-amount" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Value</label>
					<div class="input-group mb-3">
						<div class="input-group-prepend" v-show="additional_info_type == 'prefix'">
							<span class="input-group-text" id="basic-addon1">{{ additional_info }}</span>
						</div>
          	<input type="text" class="form-control" id="form-amount" placeholder="Value" v-model="value">
						<div class="input-group-append" v-show="additional_info_type == 'suffix'">
							<span class="input-group-text" id="basic-addon1">{{ additional_info }}</span>
						</div>
					</div>
        </div>
      </div>
      <div class="form-group col-12 text-right">
        <a type="button" class="btn btn-danger" href="/setting">Cancel</a>
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import Base from '@/utils/base'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
			base: null,
      key: '',
      value: '',
			additional_info: '',
			additional_info_type: '',
    }
  },
	watch: {
		value(val){
			if(this.value_type == 'number')
				this.value = this.base.to_currency_format(val)
		},
	},
  async created(){
		this.base = new Base()
    await this.get_data()
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/setting?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.key = response_data.data.key
          this.value = response_data.data.value
					this.additional_info = response_data.data.additional_info
					this.additional_info_type = response_data.data.additional_info_type
					this.value_type = response_data.data.value_type
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async save(){
      try{
        if(this.value == '')
          this.$toasted.show('Value is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.id = this.$route.query.id
          data.key = this.key
          data.value = this.value

          var response = await axios.put(base_url+'/setting',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/setting'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e) {
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    }
  }
}
</script>
